import { Component } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false
})
export class NotFoundComponent {
  public constructor(
    public userService: UserService,
  ) { }
}
